import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';

import Button from 'components/field/Button';
import EnumSelect from 'components/field/EnumSelect';
import IntegerInput from 'components/field/IntegerInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons';

const CapacityModal = NiceModal.create(({ capacity, cities, handleSubmit }) => {
	const modal = useModal();
	const [dailyCapacity, setDailyCapacity] = useState(capacity);
	const [error, setError] = useState(null);

	const onSubmit = () => {
		if (dailyCapacity === undefined) {
			setError('alert.requiredField');
			return;
		}

		handleSubmit(dailyCapacity);

		modal.remove();
	};

	return (
		<Modal maxWidth="small">
			<ModalTitle>
				<Typography variant="p1">dailyCapacity</Typography>
			</ModalTitle>
			<ModalContent>
				<Form>
					<FormItem label="city">
						<EnumSelect data={cities} label="city" multipleSelection={true} value={cities} disabled />
					</FormItem>
					<FormItem label="dailyCapacity" required>
						<IntegerInput errorMessage={error} value={dailyCapacity} setValue={setDailyCapacity} />
					</FormItem>
				</Form>
			</ModalContent>
			<ModalActions>
				<Button
					label="cancel"
					onClick={() => {
						modal.remove();
					}}
					variant="outline"
				/>
				<Button onClick={onSubmit} icon={faFloppyDisk} label="save" variant="blue" />
			</ModalActions>
		</Modal>
	);
});

export default CapacityModal;
